/**
 * ABC Brianza — Feedback Laura, settembre 2026
 * File NUOVO, separato dagli altri custom-abc-*.js per rollback rapido
 * (basta rimuovere l'inclusione in layout/theme.liquid).
 *
 * Contiene:
 * 1. Modifica 2 — click sull'indicatore "scorri" dell'hero: scroll morbido
 *    alla sezione successiva.
 * 2. Modifica 4 — toggle vista griglia/lista nelle collezioni, persistito
 *    in localStorage e riapplicato dopo ogni aggiornamento AJAX di
 *    #ProductGridContainer (filtri/sort/paginazione via facets.js).
 *
 * Caricato con `defer`, non dipende da settings.animations_reveal_on_scroll.
 */
(function () {
  'use strict';

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------
     1. Scroll cue hero
     ------------------------------------------------------------ */
  function findNextShopifySection(fromEl) {
    var section = fromEl.closest('.shopify-section');
    if (!section) return null;
    var next = section.nextElementSibling;
    while (next && !next.classList.contains('shopify-section')) {
      next = next.nextElementSibling;
    }
    return next;
  }

  document.addEventListener('click', function (event) {
    var cue = event.target.closest('[data-abc-scroll-cue]');
    if (!cue) return;

    var target = findNextShopifySection(cue);
    if (!target) return;

    target.scrollIntoView({
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
      block: 'start',
    });
  });

  /* ------------------------------------------------------------
     2. Vista lista collezioni
     ------------------------------------------------------------ */
  var ABC_VIEW_STORAGE_KEY = 'abc-collection-view';

  function getSavedView() {
    try {
      return window.localStorage.getItem(ABC_VIEW_STORAGE_KEY) === 'list' ? 'list' : 'grid';
    } catch (e) {
      return 'grid';
    }
  }

  function saveView(view) {
    try {
      window.localStorage.setItem(ABC_VIEW_STORAGE_KEY, view);
    } catch (e) {
      /* localStorage non disponibile (privacy mode, quota, ecc.): il toggle
         funziona comunque per la sessione corrente, semplicemente non
         viene ricordato al prossimo caricamento. */
    }
  }

  function applyView(container, view) {
    if (!container) return;
    var grid = container.querySelector('#product-grid');
    if (!grid) return;
    grid.classList.toggle('product-grid--list', view === 'list');

    var toggleButtons = document.querySelectorAll('[data-abc-view-btn]');
    toggleButtons.forEach(function (btn) {
      var isActive = btn.getAttribute('data-abc-view-btn') === view;
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function initViewToggle() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;

    // Applica lo stato salvato anche qui (oltre allo script inline anti-flash
    // nella section), cosi' i pulsanti toggle riflettono subito lo stato corretto.
    applyView(container, getSavedView());

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-abc-view-btn]');
      if (!btn) return;
      var view = btn.getAttribute('data-abc-view-btn') === 'list' ? 'list' : 'grid';
      saveView(view);
      applyView(document.getElementById('ProductGridContainer'), view);
    });

    // facets.js sostituisce l'innerHTML di #ProductGridContainer ad ogni
    // filtro/ordinamento/paginazione (senza sparare eventi custom dedicati):
    // un MutationObserver sui figli diretti e' il modo piu' robusto per
    // riapplicare la vista salvata, indipendente da come facets.js evolve.
    var observer = new MutationObserver(function () {
      applyView(document.getElementById('ProductGridContainer'), getSavedView());
    });
    observer.observe(container, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initViewToggle);
  } else {
    initViewToggle();
  }
})();
